export default __webpack_public_path__ + "static/media/commonocean-io.3db3f519.md";